module.exports = __webpack_public_path__ + "static/media/amex.cba282af.svg";